import * as React from "react";
const SvgLabelImportant = props => /*#__PURE__*/React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  ...props
}, /*#__PURE__*/React.createElement("path", {
  d: "M4 18.99h12.04L21 12l-4.97-7H4l5 7-5 6.99z",
  fill: "currentColor"
}));
export default SvgLabelImportant;